import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center pt-16 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-background-100/40 via-background-50/60 to-background-50"></div>

      <div className="relative w-full px-4 md:px-6 lg:px-12 py-12 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-[1400px] mx-auto">

          <div className="flex-1 text-center lg:text-left">
            <p className="text-xs md:text-sm font-medium tracking-widest uppercase text-primary-600 mb-4">
              Die größte deutschsprachige Plattform
            </p>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-foreground-950 leading-tight text-balance">
              OOPBuy Spreadsheet<br />
              <span className="text-primary-500">Deutschland</span>
            </h1>
            <p className="font-heading text-2xl md:text-3xl lg:text-4xl italic text-foreground-400 mt-3 mb-6">
              Finde alles
            </p>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto lg:mx-0 leading-relaxed mb-8">
              Entdecke organisierte Produktlisten, aktuelle Finds, Produktvergleiche und Experten-Guides für OOPBuy Nutzer aus Deutschland.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                OOPBuy Spreadsheet öffnen
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <Link
                to="/artikel/oopbuy-spreadsheet-guide-deutschland-2026"
                className="inline-flex items-center gap-2 px-7 py-3 text-sm font-semibold rounded-full border-2 border-foreground-200 text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Guide starten
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start mt-8">
              {['Aktualisierte Listen', 'Deutsche Guides', 'Produktvergleiche', 'Sicherheits-Tipps', 'Anfängerfreundlich'].map((item) => (
                <span key={item} className="flex items-center gap-1.5 text-xs text-foreground-500 whitespace-nowrap">
                  <i className="ri-check-line text-primary-500 text-sm"></i>
                  {item}
                </span>
              ))}
            </div>
          </div>

          <div className="flex-1 w-full max-w-[560px] lg:max-w-none">
            <div className="relative">
              <div className="rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20product%20flatlay%20with%20leather%20sneakers%20beige%20hoodie%20gold%20watch%20and%20minimalist%20accessories%20arranged%20organically%20on%20soft%20oatmeal%20linen%20textured%20surface%2C%20editorial%20lifestyle%20photography%2C%20soft%20diffused%20natural%20light%20from%20large%20window%2C%20warm%20earthy%20neutral%20tones%2C%20high-end%20catalog%20composition%2C%20refined%20European%20modern%20aesthetic&width=1120&height=1400&seq=hero-collage-v2&orientation=portrait"
                  alt="OOPBuy Spreadsheet Produktkollektion"
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 bg-background-50 rounded-2xl p-3 md:p-4 flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-sparkling-line text-primary-600 text-lg md:text-xl"></i>
                </div>
                <div>
                  <p className="text-lg md:text-xl font-bold text-foreground-900">500+</p>
                  <p className="text-xs text-foreground-500">Geprüfte Produkte</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}